import {
  GET_PURCASE,
  GET_PURCASE_SUCCESS,
  GET_PURCASE_FAILURE,
} from 'store/purchaseDoctor/purchaseDoctorAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const postPurchaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PURCASE:
      return { ...state, loading: true };
    case GET_PURCASE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_PURCASE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default postPurchaseReducer;
